import React, { useState, useEffect } from 'react'
import { Modal, Table } from 'antd'
import { useDingdanzhichuListQuery } from '../../store/DianShangYeWuApi'
import CostCheck from './CostCheck'
import classes from '../../invoice/cost/costInvoice.module.css'
function CostListWithId(props) {
    const [open, setOpen] = useState(false)
    const name = Array.isArray(props.id) ? props.id.join('，') : (props.id || '')
    const names = name.length > 20 ? name.slice(0, 20) + '…' : name;
    const [list, setList] = useState([])
    const {data, isSuccess} = useDingdanzhichuListQuery({ddzc_id:props.id,ddzc_qy_id:props.qy_id});         
    useEffect(() => {
        if(isSuccess){
            setList(data.Result)
        }
    }, [data, isSuccess])
    const columns = [
        {
            title: '付款客户',
            dataIndex: 'ddzc_kh_name',
            key: 'ddzc_kh_name',
            render: (text, record) => {
                return <CostCheck 
                            ddzc_id={record.ddzc_id} 
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            qy_id={props.qy_id}
                            qy_name={props.qy_name}
                            ddzc_kh_id={record.ddzc_kh_id}
                            ddzc_kh_name={record.ddzc_kh_name}
                            ddzc_price={record.ddzc_price}
                            ddzc_content={record.ddzc_content}
                            ddzc_date={record.ddzc_date}
                            ddzc_date_end={record.ddzc_date_end}
                            ddzc_bzd_name={record.ddzc_bzd_name}
                        />
                }
        },
        {
            title: '付款金额',
            dataIndex: 'ddzc_amount',
            key: 'ddzc_amount',
            render: (text) => <span style={{color:'green'}}>￥{text}</span>
        },
        {
            title: '编号',
            dataIndex: 'ddzc_id',
            key: 'ddzc_id',
            width: 60,
        },
    ]
    return (
        <>
            <a onClick={() => setOpen(true)}>{names}</a>
            <Modal 
                open={open} 
                onCancel={() => setOpen(false)}
                title='付款单列表'
                footer={null}
            >
                <Table 
                    columns={columns} 
                    dataSource={list} 
                    rowKey='ddzc_id'
                    className={classes.greenHeader}
                    size='small'
                    bordered
                    pagination={{
                        showTotal: (total) => `共${total}条`,
                        pageSize: 50,
                        placement: 'bottomCenter',
                        showSizeChanger: true,
                    }}
                    summary={pageData => {
                        const total = pageData.reduce((sum, row) => sum + Number(row.ddzc_amount || 0), 0);
                        return (
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={0}></Table.Summary.Cell>
                                <Table.Summary.Cell index={1} colSpan={1}>
                                    <span style={{color:'green'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })}</span>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={2} colSpan={columns.length - 2} />
                            </Table.Summary.Row>
                        );
                    }}
                />
            </Modal>
        </>
    )
}

export default CostListWithId